module.exports = __webpack_public_path__ + "img/asmodus.10158575.png";